import { useContext, useState } from "react";

import CopyToClipboard from "react-copy-to-clipboard";
import { UserContext } from "../../context/UserContext";
import QuestionManagement from "../dropItemsManagement/QuestionManagement";
import TimeAndAnswers from "../questionPage/helper/TimeAndAnswers";
import { getColor } from "../HelpFullFunction";
// import useStore from "../../Store/useStore";
import CircleDrop from "../CircleDrop";
import {
  useQuestionId,
  useSelectAQuestion,
  useSetQuestionCreatorId,
  useSetQuestionId,
} from "../../Store/QuestionSlice";
import { useLocation, useNavigate } from "react-router-dom";

export default function QuestionsMap({ questions }) {
  const { userInfo } = useContext(UserContext);
  const location = useLocation();
  const navigate = useNavigate();
  const setQuestionCreatorId = useSetQuestionCreatorId();
  const setQ = useSetQuestionId();
  const Q = useQuestionId();
  const [copySuccess, setCopySuccess] = useState(null);

  const selectedQuestion = useSelectAQuestion();
  const [isOpenMana, setIsOpenMana] = useState(false);
  const handleCopy = (questionId) => {
    setCopySuccess(questionId);

    setTimeout(() => {
      setCopySuccess(null);
    }, 2000);
  };

  const usersQuestionsMap = Object.values(questions).map((item) => {
    const question = item.question;
    const creatorName = item.user.name;
    const tagName = item.tag && item.tag.tag && item.tag.tag;
    const userId = item.user_id;
    const userPoints = item.user.points;
    const questionId = item.id;
    const createdAt = item.created_at;
    const answersLength = item.answers_count;
    return (
      <div
        className={`${"question-container radius-5 "}`}
        key={questionId}
        onClick={() => {
          setQ(questionId);
          setQuestionCreatorId(userId);
        }}>
        <div className={`relative gap-4 pl-10 pr-10 user-question-box`}>
          <header className="user-info">
            <div className={`d-grid sec-c gap-6 ${creatorName === userInfo.name ? "" : ""}`}>
              <span
                onClick={() => {
                  setQuestionCreatorId(userId);
                }}
                className={`txt-center text-size-100`}>
                {creatorName}
              </span>
              <span className="succ-c text-size-90">{userPoints}xp</span>
            </div>
            <CopyToClipboard text={questionId} onCopy={() => handleCopy(questionId)}>
              <span className="mixed-c pointer absolute center-x text-size-90">
                Id:{questionId}
                {questionId === copySuccess && " Copied"}
              </span>
            </CopyToClipboard>
            <CircleDrop
              onClick={() => {
                setIsOpenMana(true);
              }}
            />

            {questionId === Q && <QuestionManagement isOpen={isOpenMana} setIsOpen={setIsOpenMana} />}
          </header>
          <p className="text-size-100 word-break sec-c cc" style={{ whiteSpace: "pre-line" }}>
            {question}

            <span
              className="sec-bg-c inline-block pl-5 pr-5 radius-3 ml-5 text-size-90  prime-c"
              style={{
                color: item.tag ? getColor(item.tag.id, 1) : null,
              }}>
              <>{tagName}</>
            </span>
          </p>
          <TimeAndAnswers
            box="question"
            view={"view post"}
            onClick={() => {
              selectedQuestion(true);
              if (location.pathname === "/") {
                navigate("/query");
              }
            }}
            time={createdAt}
            length={answersLength}
          />
        </div>
      </div>
    );
  });

  // document.body.style.overflowY = state.selectedQuestion ? "hidden" : "auto";

  return <>{usersQuestionsMap}</>;
}
